module.exports = __webpack_public_path__ + "img/mp5.cc3a98ed.png";